export default "/images/sold-flag.png?05d9f2b01c0641bc43c6694c7d8618a5";